import { rolesList } from 'lib/builders/rolesList';

/**
 * Returns true when a company user should see the tasks page / menu item.
 *
 * The `display_new_company_tasks_page_enabled` feature flag that used to gate
 * this was removed in CD-8421, and the per-company `myWorkViewEnabled`
 * setting that used to gate it was removed in CD-8650 — the redesigned
 * company tasks page, the "My work view" dashboard and the supplier
 * signposting task banner are now permanent behaviour for every company
 * user, gated purely on role.
 */
export function canCompanyUserAccessTasks(
  userRole: string | undefined
): boolean {
  return userRole === rolesList.COMPANY_USER;
}
